/* Auto-generated per-class links, keyed by the selected network — the id the
   public consent-form endpoint posts back. Both are blank without one: the seed
   contexts used before /myProfile loads have no network id, and a link built on
   their placeholder id would go nowhere.
   The two sit on different hosts on purpose: the consent form stays on the
   roomparent.com form host, the group chat opens in the app. */
export const consentFormLinkUrl = (networkId) =>
  networkId ? `https://roomparent.com/f/${networkId}` : '';

/* The group chat link is the network's own publicURL when the API has one (the
   short share link minted at creation, carried on the context from /myProfile).
   The app.joinsprout.co deep link is only the fallback for networks created
   before share links existed. */
export const groupChatLinkUrl = (networkId, publicURL = '') =>
  publicURL || (networkId ? `https://app.joinsprout.co/chat/${networkId}` : '');

/* Public, read-only view of the class to-do list, shared from the To-Do page. */
export const todoChecklistLinkUrl = (networkId) =>
  networkId ? `https://roomparent.com/todo-checklist/${networkId}` : '';

/* Public "ways to give" page for the class — lists every donation method the
   room parent added on the Links page. Same host as the consent form. */
export const donationPageLinkUrl = (networkId) =>
  networkId ? `https://roomparent.com/donate/${networkId}` : '';

/* Public sign-up page, where parents claim a slot or an item. Keyed by the
   sign-up's short code (minted by the API at create time), not its id. */
export const signupPageLinkUrl = (shortCode) =>
  shortCode ? `https://roomparent.com/signup/${shortCode}` : '';
